import React from 'react';

import { DownloadButton } from 'dashboard/pages/Segment/components/Rule/SetContainsRule/DownloadButton';
import { SetTag } from 'dashboard/pages/Segment/components/Rule/SetContainsRule/SetTag';

interface SetRuleSummaryProps {
  setFieldValue: (name: string, value: any) => void;
  base: string;
  setId: string;
}

export const SetRuleSummary = ({ setFieldValue, base, setId }: SetRuleSummaryProps) => {
  const handleDismissSet = () => {
    setFieldValue(`${base}.operation.setId`, undefined);
  };

  return (
    <>
      <SetTag
        data-cy="set-tag"
        onDismiss={handleDismissSet}
        text={`CSV: ${setId}`}
        variant="secondary"
      />
      <DownloadButton setId={setId} />
    </>
  );
};
